import { InfoCircleFilled, WarningFilled } from '@ant-design/icons';
import { clsx } from 'clsx';
import React from 'react';

export type InformationBannerVariant = 'banner' | 'text' | 'dark';

export default function InformationBanner({
  className,
  children,
  isAlert = false,
  variant = 'banner',
}: {
  children?: React.ReactNode;
  isAlert?: boolean;
  className?: string;
  variant?: InformationBannerVariant;
}) {
  const isTextVariant = variant === 'text';
  const isDarkVariant = variant === 'dark';

  return (
    <span
      className={clsx(className, 'text-sm inline-flex items-center', {
        'gap-1.5': isTextVariant,
        'p-1.5 gap-2': !isTextVariant,
        'text-orange-hellio': isTextVariant && isAlert,
        'text-black': isTextVariant && !isAlert,
        'text-gris-hellio-6 font-normal bg-bleu-hellio-1 !items-start !mb-0':
          isDarkVariant,
        'text-gris-hellio bg-orange-clair-hellio':
          !isTextVariant && !isDarkVariant && isAlert,
        'text-bleu-hellio bg-bleu-clair-hellio':
          !isTextVariant && !isDarkVariant && !isAlert,
      })}
    >
      {isAlert && (
        <WarningFilled
          className={clsx(
            'align-middle',
            !isTextVariant && 'text-orange-hellio',
          )}
        />
      )}
      {!isAlert && !isTextVariant && (
        <InfoCircleFilled
          className={clsx(
            'align-middle',
            isDarkVariant && 'text-bleu-hellio mt-1',
          )}
        />
      )}
      {children}
    </span>
  );
}
